"use client";
import { getTranslation } from "@/i18n/get-translation";
import SingleTrendingPosts from "../../single-trending-post/single-trending-post";
import { useCallback, useEffect, useState } from "react";
import { ITrendingBlogResponse } from "@/types/trending-blog.type";
import { getTrendingNews } from "@/services/trending-news.service";
import { ITrendingNewsResponse } from "@/types/trending-news.type";

const init = {
  data: [],
  meta: {
    pagination: {
      page: 0,
      pageSize: 0,
      pageCount: 0,
      total: 0,
    },
  },
};
interface INewsTrendingPosts {
  locale: string;
}
export default function NewsTrendingPosts({ locale }: INewsTrendingPosts) {
  const t = getTranslation(locale, "trendingPosts");
  const [blogs, setBlogs] = useState<ITrendingNewsResponse>(init);
  const handleFetchBlogs = useCallback(() => {
    const lang =
      locale.split("-")[0] === "en" ? "en" : `${locale.split("-")[0]}-LU`;

    getTrendingNews(lang)
      .then((res: ITrendingNewsResponse) => {
        setBlogs(res);
      })
      .catch(console.log);
  }, [locale]);
  useEffect(() => {
    handleFetchBlogs();
  }, [handleFetchBlogs]);

  return (
    <div className="w-full px-20 max-md:px-7 lg:pb-20 pb-10 relative">
      {blogs.data.length ? (
        <h2 className="text-primary-800 font-medium xl:text-[2.1rem] lg:text-[1.7rem] text-[1.35rem]    relative mb-6">
          {t("trendingTopics")}
        </h2>
      ) : ''}

      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-5 md:gap-y-8 gap-y-6">
        {blogs.data.map((blog, key) => (
          <div key={key} className="col-span-1">
            <SingleTrendingPosts
              href={`/${locale}/news/${blog.id}`}
              title={blog.attributes.new.data.attributes.title}
              imgUrl={
                blog.attributes.new.data
                  ? `${blog.attributes.new.data.attributes.poster.data.attributes.url}`
                  : "/images/clinic-image.webp"
              }
            />
          </div>
        ))}
      </div>
    </div>
  );
}
